<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold">Edit Reservation</p>
        <v-form>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="6">
              <v-currency-field
                v-model="reservationFee"
                type="number"
                :rules="reservationFeeRules"
                label="Reservation Fee"
                prepend-inner-icon="mdi-cash"
                required
              ></v-currency-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-textarea
                v-model="notes"
                label="Notes"
                placeholder="Enter notes here"
                prepend-inner-icon="mdi-text"
                required
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-switch
                v-model="moveInDateAvailable"
                label="Set Move In Date"
                color="primary"
                @change="moveInDateAvailableChange"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-menu
                ref="moveInDateMenuRef"
                v-model="moveInDateMenu"
                :close-on-content-click="false"
                :return-value.sync="moveInDate"
                transition="scale-transition"
                :disabled="!moveInDateAvailable"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="moveInDate"
                    label="Move In Date"
                    prepend-inner-icon="mdi-calendar-month"
                    :disabled="!moveInDateAvailable"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="moveInDatePicker">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="moveInDateMenu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.moveInDateMenuRef.save(moveInDatePicker)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            :disabled="!reservationFee"
            text
            @click="finish"
          >
            Finish
          </v-btn>
          <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { dayjs } from '../../util/date'

export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    options: {
      color: 'primary',
      width: 500,
      zIndex: 200
    },
    loading: false,
    reservationFee: 0,
    reservationId: -1,
    notes: null,
    moveInDate: null,
    moveInDatePicker: dayjs()
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .format('YYYY-MM-DD'),
    moveInDateMenu: false,
    snackbar: false,
    reservationFeeRules: [
      (v) => (v != null && v != undefined) || 'Reservation Fee is Required.',
      (v) =>
        Number.isInteger(parseInt(v)) || 'Reservation Fee must be a number.'
    ],
    moveInDateAvailable: false,
    reservation: null
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date)
    }
  },
  methods: {
    open(reservation) {
      this.reservation = reservation
      this.dialog = true
      this.reservationFee = reservation.reservationFee
      this.notes = reservation.notes
      this.reservationId = reservation.reservationId
      this.moveInDateAvailable =
        reservation.moveInDate == 'N/A' || reservation.moveInDate == null
          ? false
          : true
      this.moveInDate =
        reservation.moveInDate == 'N/A' || reservation.moveInDate == null
          ? null
          : dayjs(reservation.moveInDate).format('YYYY-MM-DD')
      this.moveInDatePicker =
        reservation.moveInDate == 'N/A' || reservation.moveInDate == null
          ? null
          : dayjs(reservation.moveInDate).format('YYYY-MM-DD')
      // this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    cancel() {
      this.dialog = false
      this.resolve(false)
    },
    async finish() {
      await this.$store.dispatch('reservations/editReservationAction', {
        reservationId: this.reservationId,
        reservationFee: this.reservationFee,
        notes: this.notes,
        // dateCreated: this.dateCreated,
        moveInDate: dayjs(this.moveInDate).format()
      })
      this.dialog = false
      await this.$root.$confirm({
        title: 'New Tenant',
        message: `Reservation has been updated.`,
        reconfirmOnly: true,
        confirmText: 'OK'
      })

      this.resolve(true)
    },
    moveInDateAvailableChange() {
      if (this.moveInDateAvailable) {
        this.moveInDate =
          this.reservation.moveInDate == 'N/A' ||
          this.reservation.moveInDate == null
            ? dayjs().format('YYYY-MM-DD')
            : dayjs(this.reservation.moveInDate).format('YYYY-MM-DD')
      } else {
        this.moveInDate = null
      }
    }
  }
}
</script>
